'use client';

import * as React from 'react';

// Bumped from `sidebar:state` on 2026-05-15 after fixing the inverted
// cookie comparison in shared-app-layout.tsx. Old cookies written under
// the wrong-direction logic are silently abandoned and the default-open
// preference wins on first load.
export const SIDEBAR_COOKIE_NAME = 'sidebar:state:v2';
export const SIDEBAR_COOKIE_MAX_AGE = 60 * 60 * 24 * 7;
export const SIDEBAR_WIDTH = '16rem';
export const SIDEBAR_WIDTH_MOBILE = '18rem';
export const SIDEBAR_WIDTH_ICON = '4rem';
export const SIDEBAR_KEYBOARD_SHORTCUT = 'b';

export type SidebarContext = {
  state: 'expanded' | 'collapsed';
  open: boolean;
  setOpen: (open: boolean) => void;
  openMobile: boolean;
  setOpenMobile: (open: boolean) => void;
  isMobile: boolean;
  toggleSidebar: () => void;
};

export const SidebarContext = React.createContext<SidebarContext | null>(null);

export function useSidebar() {
  const context = React.useContext(SidebarContext);

  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider.');
  }

  return context;
}
